import { render, staticRenderFns } from "./servicios.vue?vue&type=template&id=b990e0a0&scoped=true"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"
import style0 from "./servicios.vue?vue&type=style&index=0&id=b990e0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990e0a0",
  null
  
)

export default component.exports